import { render, staticRenderFns } from "./commonRes.vue?vue&type=template&id=8db4d7f4&scoped=true&"
import script from "./commonRes.vue?vue&type=script&lang=js&"
export * from "./commonRes.vue?vue&type=script&lang=js&"
import style0 from "./commonRes.vue?vue&type=style&index=0&id=8db4d7f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8db4d7f4",
  null
  
)

export default component.exports